<template>
	<DialogWindow title="Exporteren Plan van aanpak" data-testid="export-actions-dialog" class="export-dialog">
		<div class="export-dialog-content">
			<p>
				De export naar PDF bevat alleen de gefilterde acties.
				Dit is de lijst die je ook in het overzicht ziet.
			</p>

			<p>
				De export naar Excel is alleen beschikbaar voor de volledige lijst van acties en bevat zowel alle
				geplande als afgeronde actiepunten.
			</p>
			<ButtonBar>

				<BaseButton
						text="Exporteren naar PDF"
						btn-class="primary"
						@click="$emit('export', 'pdf')"
				/>

				<BaseButton
						text="Exporteren naar Excel"
						btn-class="primary"
						@click="$emit('export', 'xlsx')"
				/>
			</ButtonBar>
		</div>
	</DialogWindow>
</template>

<script generic="T extends Record<string, unknown>" lang="ts" setup>
	import DialogWindow from '~/components/generic/DialogWindow.vue';
	import BaseButton from '~/components/generic/buttons/BaseButton.vue';
	import ButtonBar from '~/components/generic/buttons/ButtonBar.vue';

	defineEmits<{
		export: [type: 'pdf' | 'xlsx']
	}>();
</script>

<style scoped>
	p ~ p {
		margin-top: var(--spacing-3);
	}
</style>
